import { LinearProgress } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import PageContentWrapper from '../../../../components/wrappers/PageContentWrapper';
import { GET_SINGLE_ARCHIVE, GET_SINGLE_ARCHIVE_VIEW, GET_SINGLE_BOX } from '../../../../enums/ApiPaths';
import { SINGLE_ARCHIVE_KEY, SINGLE_ARCHIVE_VIEW_KEY } from '../../../../enums/QueryKeys';
import { SAPS_ARCHIVE } from '../../../../enums/UrlPaths';
import { useFetch } from '../../../../hooks/Fetching';
import NotFound, { ErrorMessage } from '../../components/display/NotFound';
import { BoxViewComponent } from './SingleBoxView';

export default function SingleInpatientArchive() {
  const { t } = useTranslation();
  const { id } = useParams();
  const url = GET_SINGLE_ARCHIVE_VIEW;
  const { data, isLoading, error, isInitialLoading } = useFetch(
    url,
    id,
    SINGLE_ARCHIVE_VIEW_KEY + id,
  );

  if (isLoading || isInitialLoading) {
    return (
      <PageContentWrapper>
        <LinearProgress />
      </PageContentWrapper>
    );
  } else if (error) {
    return (
      <ErrorMessage
        title={t("SomethingWentWrong")}
        subtitle={t("FailedToFetchBox")}
      />
    );
  } else if (!data && !isLoading && !isInitialLoading && !error) {
    return (
      <PageContentWrapper>
        <NotFound title={t("ArchiveDataNotFound", { id })} />
      </PageContentWrapper>
    );
  }

  return <BoxViewComponent data={data} goBack={SAPS_ARCHIVE}/>;
}
